import { Route } from 'react-router-dom';
import MenuManager from '@yooink/youtils/es/MenuManager';
import { useLoadComponent } from '@yooink/youtils/es/hooks/useLoadComponent';
import { BsFillGiftFill } from 'react-icons/bs';
import { SiElasticsearch, SiEtcd, SiGravatar } from 'react-icons/si';
import { FaMoneyBill } from 'react-icons/fa';
import { GiWantedReward } from 'react-icons/gi';
import { GrIntegration } from 'react-icons/gr';
import { AiFillExperiment } from 'react-icons/ai';
import { AutoGiftsRulesRoute } from '../AutogiftsRules/autogiftsRulesRoute';

MenuManager.RegisterGroup({
	key: 'settings',
	name: 'Настройки',
	position: 98,
	icon: <SiEtcd />
}, []);

MenuManager.RegisterItem({
	parent: 'settings',
	name: 'Интеграции',
	icon: <GrIntegration />,
	path: '/settings/integrations'
});

MenuManager.RegisterItem({
	parent: 'system',
	name: 'Поисковый движок',
	icon: <SiElasticsearch />,
	path: '/system/search'
});

MenuManager.RegisterItem({
	parent: 'settings',
	name: 'Платежи',
	icon: <FaMoneyBill />,
	path: '/settings/payments'
});

MenuManager.RegisterItem({
	parent: 'settings',
	name: 'Подарки',
	icon: <BsFillGiftFill />,
	path: '/settings/gifts'
});

MenuManager.RegisterItem({
	parent: 'settings',
	name: 'Бонусы за действия',
	icon: <GiWantedReward />,
	path: '/settings/rewardActions'
});
MenuManager.RegisterItem({
	parent: 'settings',
	name: 'Аватарки пользователей по умолчанию',
	icon: <SiGravatar />,
	path: '/settings/defaultAvatars'
});

MenuManager.RegisterItem({
	parent: 'settings',
	name: 'Эксперименты',
	icon: <AiFillExperiment />,
	path: '/settings/features'
});

MenuManager.RegisterItem({
	parent: 'settings',
	name: 'Виджет прогреса доставки',
	icon: <AiFillExperiment />,
	path: '/settings/cardProgress'
});

export function SettingsRoute () {
	const getUrl = (...parts) => `/settings/${parts.join('/')}`;
	const getSystemUrl = (...parts) => `/system/${parts.join('/')}`;

	const Integrations = useLoadComponent(() => import('./Integrations/IntegrationsRoute').then((m) => m.IntegrationsRoute), {
		baseUrl: getUrl('integrations')
	});

	const opensearch = useLoadComponent(() => import('./OpenSearch').then((m) => m.OpenSearchSettings));

	const payments = useLoadComponent(() => import('./payments').then((m) => m.PaymentsSettings));
	const gifts = useLoadComponent(() => import('./gifts').then((m) => m.GiftsSettings));
	const features = useLoadComponent(() => import('./featuresFlags').then((m) => m.FeaturesFlagsSettings));
	const cardProgress = useLoadComponent(() => import('./CartProgressWidget').then((m) => m.CartProgressWidget));

	const rewardActions = useLoadComponent(() => import('./rewardActions').then((m) => m.RewardActionsSettings));
	const defaultAvatarsSettings = useLoadComponent(() => import('./DefaultAvatars').then((m) => m.DefaultAvatarsSettingsPage));

	return (
		<>
			<Route path={getUrl('integrations')} component={Integrations} />
			<Route exact path={getSystemUrl('search')} component={opensearch} />

			<Route exact path={getUrl('payments')} component={payments} />
			<Route
				exact
				path={getUrl('rewardActions')}
				component={rewardActions}
			/>
			<Route
				exact
				path={getUrl('defaultAvatars')}
				component={defaultAvatarsSettings}
			/>
			<Route exact path={getUrl('features')} component={features} />
			<Route exact path={getUrl('cardProgress')} component={cardProgress} />

			<Route exact path={getUrl('gifts')} component={gifts} />
			<AutoGiftsRulesRoute path={getUrl('gifts', 'auto')} />
		</>
	);
}
